//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
const userInfoURL = '/api';
const courserInfoURL = '/api';
const distributionInfoURL = '/api';
const classroomInfoURL = '/api';
import basicRequest from '@/js/basicRequest.js';

const handleFn = (data: any, parameters: any, fn: any) => {
    if (fn != undefined && typeof fn == 'function') {
        fn(data, parameters);
    }
};

import listRequest from '../../js/listRequest.js';

export const classesApi = {
    //最简单的写法，列表啥也不用做
    getClassList(opt: any, pageData?: any) {
        var servicesPath = baseURL + '/v1/class/list';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;
        let urlQueryParmas = opt.urlQueryParmas;
        if (urlQueryParmas.sort == '') {
            delete urlQueryParmas.sort;
        }
        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            data: {},
            isShowLoading: false,
            urlQueryParmas: opt.urlQueryParmas || {},
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                // console.log('--------------', data.data.list);
                return data;
            },
            afterRender: opt.afterRender || function () {}
        });
    },
    getAllClassList(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/v1/class/classes';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlQueryParmas,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },

    getStudentList(opt: any, pageData?: any) {
        var servicesPath = userInfoURL + '/v1/user/list/';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;
        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            isShowLoading: false,
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            appendAttributes: opt.appendAttributes || {},
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                // console.log('-------学生-------', data.data.list);
                return data;
            },
            afterRender: opt.afterRender || function () {}
        });
    },

    getAuthorizaList(opt: any, pageData?: any) {
        var servicesPath = baseURL + '/authorize/list';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            waitingtip: '加载中，请稍等...',
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                // console.log('--------------', data.data.list);
                return data;
            }
        });
    },

    // getStudentByClassId(opt: any, pageData?: any) {
    //     var servicesPath = baseURL + '/v1/class/student/list';
    //     let context = opt.context;
    //     let pager = opt.pager;
    //     let initCodeRules = opt.initCodeRules;

    //     listRequest.request({
    //         url: servicesPath,
    //         context: context,
    //         pager: pager,
    //         waitingtip: '加载中，请稍等...',
    //         data: {},
    //         urlQueryParmas: opt.urlQueryParmas || {},
    //         prepareRender(data: any) {
    //             //如果列表需要显示编码的中文，则需要重写prepareRender
    //             context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
    //             // console.log('-------班级学生-------', data.data.list);
    //             return data;
    //         }
    //     });
    // },

    cancelAuthorization(opt: any) {
        var servicesPath = distributionInfoURL + '/distribution/class';
        let context = opt.context;
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getClassesById(opt: any) {
        var servicesPath = baseURL + '/v1/class';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj._id;
        // console.log(servicesPath);
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                    // console.log(data)
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    saveClasses(opt: any) {
        var servicesPath = baseURL + '/v1/class';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'POST';
        if (pageData._id != undefined && pageData._id != '') {
            ajaxType = 'PUT';
            servicesPath += '/' + pageData._id;
            delete pageData._id;
        }

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    saveStudent(opt: any) {
        var servicesPath = userInfoURL + '/v1/user';
        let context = opt.context;
        let pageData = opt.data || {};
        let ajaxType = 'POST';
        if (pageData._id != undefined && pageData._id != '' && pageData._id != -1) {
            ajaxType = 'PUT';
            servicesPath += '/' + pageData._id;
            delete pageData._id;
        }
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getStudentById(opt: any) {
        var servicesPath = userInfoURL + '/v1/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;
        // console.log(servicesPath);
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    deleteClassStudent(opt: any) {
        var servicesPath = baseURL + '/v1/class/student';
        let context = opt.context;
        let pageData = opt.data || {};

        // console.log(pageData);

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    deleteUserById(opt: any) {
        var servicesPath = userInfoURL + '/v1/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getSchoolById(opt: any) {
        var servicesPath = baseURL + '/v1/school';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getClassStudentList(opt: any) {
        var servicesPath = baseURL + '/v1/class/student/list';
        let context = opt.context;
        listRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            urlQueryParmas: opt.urlQueryParmas || {},
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getClassById(opt: any) {
        var servicesPath = baseURL + '/v1/class';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    deleteStudentById(opt: any) {
        var servicesPath = userInfoURL + '/v1/user';

        let context = opt.context;
        servicesPath += '/' + opt.id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getTeacherByClassIdList(opt: any) {
        var servicesPath = baseURL + '/v1/class/teacher/list/classlist';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            waitingtip: '加载中，请稍等...',
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getPublishedCourseList(opt: any) {
        var servicesPath = distributionInfoURL + '/distribution/course/school';
        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            },
            afterRender: opt.afterRender || function () {}
        });
    },
    authorizeCourseByClassId(opt: any) {
        var servicesPath = distributionInfoURL + '/distribution/class';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'POST';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getCourseListByClassId(opt: any) {
        var servicesPath = distributionInfoURL + '/distribution/class';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            isShowLoading: false,
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            appendAttributes: opt.appendAttributes || {},
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                // console.log('--------------', data.data.list);
                return data;
            },
            afterRender: opt.afterRender || function () {}
        });
    },
    UnAuthorizeBook(opt: any) {
        var servicesPath = distributionInfoURL + '/distribution/class';
        let context = opt.context;
        listRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            urlQueryParmas: opt.urlQueryParmas || {},
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            },
            afterRender: opt.afterRender || function () {}
        });
    },
    exportClassStudent(opt: any) {
        var servicesPath = baseURL + '/v1/user/export/class/student';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            data: pageData,
            responseType: 'blob', //返回的数据类型
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 批量设置学生有效期  http://yapi.dm-ai.cn:3000/project/163/interface/api/26610
    batchValidity(opt: any) {
        var servicesPath = baseURL + '/v1/user/batch/renew/expireTime';
        let context = opt.context;
        let pageData = opt.data || {};
        let ajaxType = 'PUT';

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 班级管理——删除班级  http://yapi.dm-ai.cn:3000/project/334/interface/api/3265
    deleteClass(opt: any) {
        var servicesPath = baseURL + '/v1/class';

        let context = opt.context;
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 获取学校各年级班级数量  http://yapi.dm-ai.cn:3000/project/334/interface/api/26815
    getGradeCount(opt: any) {
        var servicesPath = baseURL + '/v1/class/grade/count';
        let context = opt.context;

        listRequest.request({
            url: servicesPath,
            context: context,
            urlQueryParmas: opt.urlQueryParmas || {},
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 班级管理——查看学生，将学生移出本班  http://yapi.dm-ai.cn:3000/project/163/interface/api/26790
    deleteStudentInClass(opt: any) {
        var servicesPath = baseURL + '/v1/user/remove/student/' + opt.id;
        let context = opt.context;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 班级管理——关联课程，取消关联教师与班级课程的关联  http://yapi.dm-ai.cn:3000/project/334/interface/api/4560
    deleteTeacherInClass(opt: any) {
        var servicesPath = baseURL + '/v1/class/teacher';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 不分页获取班级  http://yapi.dm-ai.cn:3000/project/334/interface/api/26055
    getClass(opt: any) {
        var servicesPath = baseURL + '/v1/class/classes';
        let context = opt.context;

        listRequest.request({
            url: servicesPath,
            context: context,
            urlQueryParmas: opt.urlQueryParmas || {},
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 分页获取班级  http://yapi.dm-ai.cn:3000/project/334/interface/api/3255
    getClassPage(opt: any) {
        var servicesPath = baseURL + '/v1/class/list';
        let context = opt.context;

        listRequest.request({
            url: servicesPath,
            context: context,
            urlQueryParmas: opt.urlQueryParmas || {},
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
